var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('router-view'),_c('div',{staticClass:"my-12"}),_c('dashboard-core-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }